import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { SignalEventsDataDto, SignalEventsRequestParams } from "../../../company/types/signals";
import { accountOverviewQueryKeys } from "../queryKeyFactory";

type QueryOptions = {
    isEnabled?: boolean;
};

export default function useSignalsEventsForTooltipQuery(
    params: SignalEventsRequestParams,
    options: QueryOptions = {},
): UseQueryResult<SignalEventsDataDto> {
    const { isEnabled = false } = options;

    return useQuery({
        queryKey: accountOverviewQueryKeys.companySignalsEventsForTooltip(params.domain, params.includeRegionalDomains),
        enabled: isEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryFn({ signal }) {
            return salesApiService.accountOverview.fetchSignalEventsForTooltip(params, {
                cancellation: signal,
            });
        },
    });
}
